export const FeatureFlags = {
  BHX_PROVIDER_BIOS_IN_BOOKING_EXPERIMENT: 'provider-bios-in-booking-experiment',
  BHX_RECOMMENDED_SERVICES_MENTAL_HEALTH_CARD: 'recommended-services-mental-health-card',
  CONSUMER_PEDIATRIC_REGISTRATION_EMAIL_VERIFICATION_STEP: 'consumer-pediatric-registration-email-verification',
  CONSUMER_REGISTRATION_APPLE_PAY_WEB: 'consumer-registration-apple-pay-web',
  CONSUMER_REGISTRATION_DAY_1_BANNER: 'consumer-registration-day-1-banner',
  CONSUMER_REGISTRATION_EXPERIMENTATION_TEST: 'consumer-registration-experimentation-test',
  CONSUMER_REGISTRATION_GIFTING_POLLING_FLOW: 'consumer-registration-gifting-polling-flow',
  CONSUMER_REGISTRATION_INSTALLMENT_PAYMENTS: 'consumer-registration-installment-payments',
  CONSUMER_REGISTRATION_MEMBERSHIP_SERVICE_PUSHER_REFACTOR: 'consumer-registration-membership-service-pusher-refactor',
  CONSUMER_REGISTRATION_PASSWORDLESS_FIRST_PAGE: 'consumer-registration-passwordless-first-page',
  CONSUMER_REGISTRATION_PROMOTION: 'consumer-registration-promotion',
  CONSUMER_REGISTRATION_SERVICE_AREA_CAPACITY_ALERT_MODAL: 'consumer-registration-service-area-capacity-alert-modal',
  CONSUMER_REGISTRATION_SERVICE_AREA_ADULT_EXCLUSIONS:
    'consumer-registration-exclude-enterprise-only-service-areas-from-adult-flow',
  CONSUMER_REGISTRATION_UPSELL_VIRTUAL_OFFERING: 'consumer-registration-upsell-virtual-offering',
  CONSUMER_REGISTRATION_QUERY_PARAM: 'consumer-registration-query-param',
  CONSUMER_REGISTRATION_SERVICE_AREA_CAPACITY_BLOCK: 'consumer-registration-service-area-capacity-block',
  CONSUMER_REGISTRATION_STEP_BASED_BANNER: 'consumer-registration-step-based-banner',
  CONSUMER_REGISTRATION_STRIPE_PAYMENT_INTENTS: 'consumer-registration-stripe-payment-intents',
  CONSUMER_REGISTRATION_VALUE_PROPS_INTERSTITIAL: 'consumer-registration-value-props-interstitial-step-rev-2',

  ENTERPRISE_REGISTRATION_DISALLOW_WORK_EMAIL_FOR_LOGIN: 'disallow-work-email-as-login-email-for-b2b',

  ENABLE_UPLOADED_FILE_NAME_SANITIZATION: 'enable-uploaded-file-name-sanitization',
  FAMILY_ACCOUNT_MANAGEMENT_TAB: 'family-account-management-tab',
  GRAPHQL_MIGRATION_APPOINTMENT_CONFIRMATION: 'graphql-migration-appointment-confirmation',
  HOME_SCREEN_LEGACY_RECOMMENDED_SERVICES: 'home-screen-legacy-recommended-services',
  HINT_PORTAL_PEAK_MED_MEMBERS: 'hint-portal-peak-med-members',
  POST_REGISTRATION_BOOKING: 'post-registration-booking',
  BHX_MEMBER_PROGRAM_EXPERIENCE: 'member-program-experience',
  BHX_MENTAL_HEALTH_TOPIC_ROUTING_FEATURE: 'mental-health-topic-routing-feature',
  PATIENT_UI_MAINTENANCE_MODE: 'patient-ui-maintenance-mode',
  PROACTIVE_CARE_ENABLE_CONCIERGE: 'proactive-care-enable-concierge',
  PC_GRAPHQL_NOTIFICATION_TARGETS: 'pc-messages-notification-targets-use-graphql',
  REGISTRATION_FAMILY_ROUTING_FAQS: 'registration-family-routing-faqs',
  PATIENT_TASK_DETAILS_GRAPHQL: 'patient-task-details-graphql',
  TOPIC_BASED_GUIDANCE: 'topic-based-guidance',
  TOPICS_SECTION_HOMESCREEN: 'topics-section-homescreen',
  TOPIC_DETAILS_PAGE: 'topic-details-page',
  REGISTRATION_INSURANCE_LINK: 'registration-insurance-lookup-link',
  REGISTRATION_MFA_CONSUMER: 'mfa-step-consumer-registration',
  REGISTRATION_MFA_PEDIATRIC: 'mfa-step-pediatric-registration',
  REGISTRATION_MFA_DSU: 'mfa-step-dsu',
  REGISTRATION_MFA_PEDIATRIC_DSU: 'mfa-step-pediatric-dsu',
  ACCOUNT_SETTINGS_CONNECTED_DEVICES: 'account-settings-connected-devices',
  PATIENT_DOWNLOAD_EHI_EXPORT: 'patient-download-ehi-export',
  EHI_EXPORT_HISTORY: 'ehi-export-history',
  PC_UPDATED_NOTIFICATION_TARGETS: 'pc-updated-notification-targets',
  IMPROVED_MEDICAL_RECORDS_RELEASE_FORMS: 'improved-medical-records-release-forms',
  NO_COOKIE_FOR_YOU: 'no-cookie-for-you',
  HOMEPAGE_SHOW_INFO_MODAL_FOR_FIRST_REMOTE_VISIT: 'web-show-info-modal-for-first-remote-visit',
  BILLABLE_VISIT_CLARITY_HOMESCREEN_SECTIONS: 'billable-visit-clarity-homescreen-sections',
  HOMESCREEN_TMN_RENAMING: 'homescreen-tmn-renaming',
  TOUCAN_AI_FAQS_WEBVIEW: 'toucan-ai-fa-qs-on-webview',
  WEB_REBRAND: 'web-rebrand',
  REACT_TO_SUBMIT_TIMEOUT: 'react-to-submit-timeout-exceeded',
  ENABLE_PRESIGNED_URL_PATIENT_UI: 'enable-presigned-url-patient-ui',
  PLAN_DETAILS_EXPIRATION_WARNING: 'plan-details-expiration-warning',
  ENROLLMENT_PRESELECT_SERVICE_AREA: 'enrollment-preselect-service-area',

  // Hornbill
  HORNBILL_ENABLE_FAMILY_TYPE_PAGE_ANALYTICS: 'hornbill-enable-family-type-page-analytics',
  HORNBILL_ENROLLMENT_P0_ENABLED: 'hornbill-enrollment-p0-enabled', // Hornbill Enrollment related P0 features
  HORNBILL_REGISTRATION_BANNER: 'hornbill-registration-reminder-banner',
  HORNBILL_MEMBERSHIP_MANAGEMENT_P0_ENABLED: 'hornbill-membership-mgmt-p0-enabled',
  HORNBILL_PRIME_PROMO_BANNER: 'hornbill-prime-promo-banner',
  HORNBILL_ADD_FAMILY_PROMPT_CARD: 'hornbill-add-family-prompt-card',
  HORNBILL_SHOW_UPSELL_NOTICE: 'show-prime-subscription-upsell-notice',
  HORNBILL_SHOW_RENEWAL_OPTIONS: 'direct-renewal-links-to-renewal-options-page',
  SKIP_MEMBERSHIP_VALIDATION_CHECK: 'skip-membership-validation-on-patient-ui',
  HORNBILL_ENABLE_PRIME_REFERRAL_CODE: 'show-pom-referral-code',

  /* START PHARMEX */
  PHARMEX_PREFERRED_PHARMACY_REVAMP: 'pharmex-preferred-pharmacy-revamp',
  PHARMEX_APEE_RX_INSURANCE_TRANSFER: 'pharmex-apee-rx-insurance-transfer',
  /* END PHARMEX */

  // LWA
  LOGIN_WITH_AMAZON: 'login-with-amazon',
  REGISTER_WITH_AMAZON: 'register-with-amazon',
  HIDE_LWA: 'hide-lwa',
  DIRECT_AMAZON_ACCOUNT_LINKING_ENABLED: 'direct-amazon-account-linking-enabled',

  // GCN
  GCN_ENGAGEMENT_INTERSTITIAL_PAGE_ENABLED: 'gcn-engagement-interstitial-page-enabled',

  // Kestrel
  ENHANCED_FUNCTIONALITY_FOR_LIMITED_ACCESS_USERS: 'enhanced-functionality-for-limited-access-users',
  LIMITED_ACCESS_UPGRADE_MEMBERSHIP: 'limited-access-upgrade-membership',
  LIMITED_ACCESS_ENROLLMENT_SERVICE_AREAS: 'limited-access-enrollment-service-areas',
  LIMITED_ACCESS_ENROLLMENT_DISABLE_UPGRADE_MEMBERSHIP_LINK:
    'limited-access-enrollment-disable-upgrade-membership-link',
  LIMITED_ACCESS_ON_REG_RESUMPTION_SKIP_TOS_CHECK: 'limited_access_on_reg_resumption_skip_tos_check',
  UPGRADE_URL_CHANGE: 'upgrade-url-change',
  ADD_LEGACY_PLAN_FOR_LWA: 'add-legacy-plan-for-lwa',
  EXPIRED_TO_GUEST_CONVERSION_WEB: 'expired-to-guest-conversion-web',
  EXPIRED_TO_GUEST_CONVERSION_UPGRADE_URL_CHANGE: 'expired-to-guest-conversion-upgrade-link',

  // Guest Visit
  LIMITED_ACCESS_UNIFIED_EXP_WEB: 'limited-access-unified-exp-web',
  LIMITED_ACCESS_SIGNUP_LINK: 'limited-access-signup-link',

  // Mobile App Strategy
  HOMESCREEN_NOTIFY_TERMS_OF_SERVICE: 'homescreen-notify-terms-of-service',

  // Insurance Capture Web
  INSURANCE_CAPTURE_CARRIER_DROPDOWN_SEARCH: 'insurance-capture-carrier-dropdown-search',
  INSURANCE_CAPTURE_REQUIRED: 'insurance-capture-required',
  SELF_PAY_ESTIMATES: 'display-self-pay-estimates',

  // Payment Capture Web
  INSURANCE_CAPTURE_WEB_FULL_PAGE: 'insurance-capture-full-page-web',
  PAYMENT_CAPTURE_MILESTONE_3: 'payment-capture-milestone-3',
  SKIP_PAYMENT_CAPTURE_NEW_INSURANCE: 'skip-payment-capture-new-insurance',
  SKIP_PAYMENT_CAPTURE_EXISTING_INSURANCE: 'skip-payment-capture-existing-insurance',
  PAYMENT_CAPTURE_WEB_DEV_MODE: 'payment-capture-web',

  // Appointment Booking Experience
  REMOVE_MEMBER_ABILITY_TO_COMPLETE_VACCINE_ORDERS: 'remove-member-ability-to-complete-vaccine-orders',
  APPOINTMENT_VISIT_FILTER_TOGGLE: 'appointment-type-filter-toggle',
  APPOINTMENT_BOOKING_FLOW_SIMPLIFICATION: 'appointment-booking-flow-simplification',
  APPOINTMENT_BOOKING_FLOW_SIMPLIFICATION_DESKTOP_NAV_INGRESS: 'appointment-booking-simplification-desktop-nav-ingress',
  SCROLLABLE_APPOINTMENT_INVENTORY: 'scrollable-appointment-inventory',
  BOOKING_CONFIRMATION_NSLC_DISCLAIMER: 'booking-confirmation-nslc-disclaimer',
  STRUCTURED_REASON_FOR_VISIT_TYPEAHEAD_DEBOUNCE: 'structured-reason-for-visit-typeahead-debounce',
  PCP_SELECTION_PROVIDER_BIO_SANITIZATION_ENABLED: 'pcp-selection-provider-bio-sanitization-enabled',

  // Scheduling
  OMNI_MSA_SEARCH_INVENTORY: 'omni-msa-search-inventory',
  OMNI_MSA_STOP_SERVICE_AREA_REFRESH: 'omni-msa-service-area-refresh',

  // Scribe
  PATIENT_WEB_BOOKING_FLOW_SCRIBE_CONSENT: 'patient-web-booking-flow-scribe-consent',
  SCRIBE_FAQS_WEBVIEW: 'scribe-faq-on-webview',
  ENABLE_WEB_BOOKING_SCRIBE_CONSENT_PEDIATRIC: 'enable-web-booking-scribe-consent-pediatric',

  // Senior Health
  SENIOR_HEALTH_HOMESCREEN: 'senior-health-homescreen-patient-ui',
  SELF_SERVICE_CLAIMING_LINKS: 'self-service-claiming-links',
  HUMMINGBIRD_UPDATED_HIE_FORM_UI: 'hummingbird-updated-hie',
  HUMMINGBIRD_PATIENT_UI_USE_NEW_MESSAGE_ENTITLEMENT: 'hummingbird-patient-ui-use-new-message-entitlement',
  HUMMINGBIRD_DEFAULT_HIE_OPT_IN: 'hummingbird-default-hie-on',

  // Zocdoc registration flag
  ZOCDOC_REGISTRATION_GRAPHQL_FIELDS: 'zocdoc-registration-graphql-fields',

  // FTC NOR
  HIDE_NOR_DOUBLE_OPT_IN: 'hide-nor-double-opt-in',
  NOR_LEGAL_TERMS_UPDATE: 'nor-legal-terms-update',
  NOR_SHOW_NEW_CANCEL_BUTTON: 'nor-cancel-button',
  NOR_RECORD_KEEPING: 'ftc-nor-record-keeping-enabled',
  ENABLE_AUTO_RENEWAL_MODAL: 'enable-auto-renewal-modal',
  TERMS_OF_USE_UPDATED_URL: 'terms-of-use-updated-url',
  NOR_RECORD_KEEPING_FOR_APPLE_PAY: 'ftc-nor-record-keeping-apple-pay-checkout',

  // Add Payment Method Public Routing
  ADD_PAYMENT_METHOD_PUBLIC_ROUTING: 'add-payment-method-public-routing',

  // Pathways
  PATHWAYS: 'pathways',
  TREATMENT_PLAN_PAGE: 'treatment-plan-page',
  CONDITION_DETAIL_PAGE: 'condition-detail-page',

  // Depression Screening
  ONELIFE_DEPRESSION_SCREENING_OUTREACH_FRONTEND: 'onelife-depression-screening-outreach-frontend',

  // Remote Primary Care
  REMOTE_PRIMARY_CARE_ENABLED: 'rpc-enabled',
  REMOTE_PRIMARY_CARE_ENROLLMENT_FLOW: 'remote-primary-care-enrollment-flow',

  // Account Recovery Enhancement
  OM_ACCOUNT_RECOVERY_ENHANCEMENT: 'om-account-recovery-enhancement',
} as const;
export type FeatureFlags = typeof FeatureFlags[keyof typeof FeatureFlags];

export enum HomeRedesignVariation {
  OFF = 'Off',
  ON_ALTERNATE_TEXT = 'OnAlternateText',
}

export enum ScribeConsentVariation {
  PRE = 'Pre',
  POST = 'Post',
  NONE = 'None',
}

/**
 * Variants for LaunchDarkly (LD) x MixPanel (MP) workaround.
 */
export const FeatureFlagVariants = {
  /** Indicates the experiment is not running and should tell the client to not send LD parameters to MP*/
  OFF: 'OFF',
  /** Indicates the experiment is running and should tell the client to send LD parameters to MP for members assigned to the control group*/
  ON_CONTROL: 'ON CONTROL',
  /** Indicates the experiment is running and should tell the client to send LD parameters to MP for members assigned to the variant group*/
  ON_VARIANT: 'ON VARIANT',
  /** When there are more than 1 variant */
  ON_T1: 'ON T1',
  ON_T2: 'ON T2',
} as const;
export type FeatureFlagVariants = typeof FeatureFlagVariants[keyof typeof FeatureFlagVariants];

/**
 * Variants for LaunchDarkly (LD) x MixPanel (MP) workaround with `ON` variation
 */
export const FeatureFlagVariantsWithOn = {
  ...FeatureFlagVariants,
  /** Indicates the experiment is running and should tell the client to not send LD parameters to MP.*/
  ON: 'ON',
} as const;
export type FeatureFlagVariantsWithOn = typeof FeatureFlagVariantsWithOn[keyof typeof FeatureFlagVariantsWithOn];
